import { Plus, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export function AuthorizationsListPanel({
  title,
  description,
  draft,
  items,
  placeholder,
  addLabel,
  testIdPrefix,
  onDraftChange,
  onAdd,
  onRemove,
}) {
  return (
    <section
      className="rounded-2xl border border-slate-200/80 bg-white p-4"
      data-testid={`${testIdPrefix}-panel`}
    >
      <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
      <p className="mt-1 text-xs text-slate-500">{description}</p>
      <div className="mt-3 flex gap-2">
        <Input
          value={draft}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onAdd();
            }
          }}
          placeholder={placeholder}
          data-testid={`${testIdPrefix}-input`}
        />
        <Button type="button" onClick={onAdd} data-testid={`${testIdPrefix}-add`}>
          <Plus className="mr-1 h-4 w-4" /> {addLabel}
        </Button>
      </div>
      <ul className="mt-3 space-y-1.5">
        {items.length === 0 ? (
          <li className="text-xs text-slate-400">No entries yet.</li>
        ) : (
          items.map((item) => (
            <li
              key={item}
              className="flex items-center justify-between rounded-lg border border-slate-100 bg-slate-50/70 px-3 py-2 text-sm text-slate-800"
            >
              <span className="truncate">{item}</span>
              <button
                type="button"
                onClick={() => onRemove(item)}
                className="rounded p-1 text-slate-400 hover:bg-white hover:text-red-600"
                aria-label={`Remove ${item}`}
                data-testid={`${testIdPrefix}-remove-${item}`}
              >
                <X className="h-4 w-4" />
              </button>
            </li>
          ))
        )}
      </ul>
    </section>
  );
}
